// ##### 25-03-26 Komarov
import {
  GET_LOADED_PAGE_ERR,
  GET_LOADED_PAGE_REQ,
  GET_LOADED_PAGE_RES,
  GET_PAGES_ERR,
  GET_PAGES_REQ,
  GET_PAGES_RES,
  SET_PAGES_REDUX,
} from '../constants';
// ##### 25-01-09 Komarov
import { getUrl } from '../../helpers/crypto';
// ##### 25-02-26 Komarov
import { uniLog } from '../../../server/helpers/uniLog';
// ##### 25-03-28 Komarov
import { getSavingDataClient } from '../../helpers/saveData';
import { getPagesToRedux } from '../../helpers/messages';

// ##### 24-03-21 Komarov
export const getPages = lang => async dispatch => {
  dispatch({ type: GET_PAGES_REQ });
  // console.log('REDUX_LOCALE:',lang)
  // ##### Komarov 2025-08-05
  // ##### Komarov 2025-08-02: Используем пришедшие pages для заполнения state в pagesRedux на соотвествующем языке
  const processDataFunction = async res => {
    const pagesRedux = getPagesToRedux({ pages: await res, language: lang });
    dispatch({ type: SET_PAGES_REDUX, payload: pagesRedux });
    return await res;
  };

  // ##### 25-01-09 Komarov
  const url = getUrl('classifier', `classifier=sitepage&language=${lang}`);

  // ##### 25-02-26 Komarov
  uniLog('pages.js', 'axios:src/Redux/actions/pages.js:getPages, url:', url);

  // ##### 25-03-28 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
  await getSavingDataClient({
    smartUrl: url,
    typeRes: GET_PAGES_RES,
    typeErr: GET_PAGES_ERR,
    dispatch,
    processDataFunction,
  });
};

// ##### 25-04-21 Komarov: TODO: Разделить запросы и сохранение контента в разных разделах Redux state (пока) для разных интерпретаций id в url страниц на сайте
export const getLoadedPage =
  ({
    spid,
    lang,
    deviceType = 'desktop',
  }) =>
  async dispatch => {
    // ##### 25-04-23 Komarov
    const processDataFunction = async res => {
      return {
        spid,
        lang,
        data: await res,
      };
    };

    const url = getUrl(
      'sitepagecontent',
      `id=${spid}&language=${lang}&deviceType=${deviceType}`
    );

    // ##### 25-03-05 Komarov
    uniLog(
      'pages.js',
      'axios:src/Redux/actions/pages.js:getLoadedPage, url:',
      url
    );

    // ##### 25-03-28 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
    await getSavingDataClient({
      smartUrl: url,
      typeRes: GET_LOADED_PAGE_RES,
      typeErr: GET_LOADED_PAGE_ERR,
      dispatch,
      processDataFunction,
    });

    dispatch({ type: GET_LOADED_PAGE_REQ, payload: { spid, lang } });
  };
